import store from '@/store'
import { mylinkStartLoading, mylinkStopLoading } from './const'
function loadingGif(status) {
  let loadingMaskEl = document.getElementById("loading-marsk");
  let attr = status ? "flex" : "none";
  loadingMaskEl!.style.display = attr;
}
const setLoadingOld = (v: boolean) => {
  // store.dispatch('load/loadOn', v)
  loadingGif(v)
}


const setLoading = (v:boolean) =>{
  if(v===true){
    mylinkStartLoading(()=>setLoadingOld(v))
  }
  if(v===false){
    mylinkStopLoading(()=>setLoadingOld(v))
  }
}

export default setLoading
